import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectTaskFieldsCulturesIds } from '../../slice/selectors';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

export const WarningCircle = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background: #ffa39e;
  margin: auto 0 auto 10px;
`;

interface IProps {
  seedCultureId: number;
}

const SeedCultureWarning: FC<IProps> = ({ seedCultureId }) => {
  const { t } = useTranslation();

  const taskFieldsCulturesIds = useSelector(selectTaskFieldsCulturesIds);

  const isFieldsMatchingVariation =
    taskFieldsCulturesIds.length === 1 &&
    taskFieldsCulturesIds[0] === seedCultureId;

  if (isFieldsMatchingVariation) {
    return null;
  }

  return (
    <Tooltip
      placement="right"
      title={t(
        'Task.WrongSeedWarning.SeedCultureDoesntMatchFieldsCulture',
        'The planned culture does not correspond to the selected seed variation.',
      )}
    >
      <WarningCircle />
    </Tooltip>
  );
};

export default SeedCultureWarning;
